<!--
  The shell every Insights page renders in. The header goes into the top bar (PageHeaderPortal)
  with the navy tile, the page's title and an "Insights" eyebrow. Below it come the filter bar
  (slot "filters"), the scope line, any error, and the page's cards.

  The scope line: the API returns each user only the branches their access covers (the
  GetInsightHeader branch list). A filtered page that doesn't say it's filtered reads as the
  whole company, so for anyone who isn't Corp the page says how many branches it covers. This
  is the same reasoning as Revenue Analysis's scope banner.
-->
<template>
  <div class="calc-page ins-page">
    <PageHeaderPortal>
      <div class="calc-header">
        <div class="calc-header__icon"><i :class="icon"></i></div>
        <div>
          <p class="ins-eyebrow">Insights</p>
          <h1 class="calc-header__title">{{ title }}</h1>
          <p v-if="subtitle" class="calc-header__sub">{{ subtitle }}</p>
        </div>
      </div>
    </PageHeaderPortal>

    <div v-if="$slots.actions" class="ins-header-actions">
      <slot name="actions" />
    </div>

    <slot name="filters" />

    <div v-if="scopeText" class="ins-banner">
      <i class="fa-light fa-building"></i>
      <div>{{ scopeText }}</div>
    </div>

    <div v-if="error" class="ins-banner ins-banner--error" role="alert">
      <i class="fa-solid fa-circle-exclamation"></i>
      <div><b>An error occurred.</b> {{ error }}</div>
    </div>

    <slot />
  </div>
</template>

<script>
import PageHeaderPortal from '@/views/PageHeaderPortal.vue'
import { insightGates } from '@/helpers/insights/insightPages.js'

export default {
  name: 'InsightPage',
  components: { PageHeaderPortal },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    icon: { type: String, default: 'fa-light fa-chart-column' },
    error: { type: String, default: '' },
    // The GetInsightHeader payload, from InsightFilterBar's `header` event.
    header: { type: Object, default: null }
  },
  computed: {
    scopeText() {
      if (!this.header || insightGates().corp) return ''
      const n = (this.header.branchlist || []).length
      if (!n) return ''
      return n === 1
        ? `Showing branch ${this.header.branchlist[0]}, the branch your access covers.`
        : `Showing the ${n} branches your access covers.`
    }
  }
}
</script>

<style scoped>
.ins-eyebrow { margin: 0 0 1px; font-size: 12px; font-weight: 700; color: var(--calc-muted, #7b8397); }
.ins-header-actions { display: flex; justify-content: flex-end; gap: 8px; flex-wrap: wrap; margin-bottom: -4px; }
</style>
